<template>
  <section class="content">
    <form @submit.prevent="validateForm">
      <fieldset class="of-radios-and-checks">
        <h4>Escolha o valor</h4>
        <div
          v-for="pledge in pledges"
          :key="pledge"
          class="input-wrapper"
        >
          <input
            :id="`amount_${pledge}`"
            v-model="amount"
            type="radio"
            name="amount"
            :value="pledge"
            @change="validateForm"
          >
          <label
            :for="`amount_${pledge}`"
            class="bigger"
          >R$ {{ pledge | formatBRL }}</label>
        </div>

        <div
          id="outro-valor"
          class="input-wrapper input-wrapper--full-width"
        >
          <input
            id="amount_other"
            v-model="amount"
            type="radio"
            name="amount"
            value="other"
          >
          <label for="amount_other">outro valor</label>
        </div>

        <div
          v-if="amount === 'other'"
          class="input-wrapper has-real-value"
        >
          <label for="other">R$</label>
          <input
            ref="otherAmountField"
            v-model="other"
            v-mask="'########'"
            type="tel"
            name="other"
            pattern="[0-9]*"
            :disabled="amount === 'other' ? false : true"
          >
          <span class="real-value">{{ formatedOther }}</span>
          <button
            type="button"
            href="#"
            @click.prevent="validateForm"
          >
            OK
          </button>
        </div>
      </fieldset>
      <fieldset class="checkbox-custom">
        <div class="input-wrapper">
          <label for="maxdonation">
            <p>
              Declaro que minhas doações não ultrapassam 10% dos meus rendimentos brutos do ano anterior, a origem do dinheiro não é estrangeira, não sou concessionário ou permissionário de serviço público.
            </p>
            <p>Declaro estar ciente, que ao realizar uma doação, por conta da legislação eleitoral, os seus dados (nome completo, CPF, valor individual de cada doação, forma de pagamento, data das doações) serão publicados de forma pública no site do candidato, na aba transparência, e concordo com os <a
              :href="contract"
              target="_blank"
            >termos de doação</a>.</p>
            <span class="btn-accept-terms-of-use donation-nav donation-nav--forward">Aceitar e continuar</span>
          </label>
          <input
            id="maxdonation"
            ref="maxdonation"
            v-model="maxdonation"
            type="checkbox"
            name="maxdonation"
            @change="checkAmount"
          >
        </div>
      </fieldset>
      <p
        v-show="errorMessage"
        ref="errorMessageEl"
        class="error"
        tabindex="-1"
      >
        {{ errorMessage }}
      </p>
    </form>
  </section>
</template>

<script>
import { validate, formatBRLDec, formatBRL, getQueryString } from '../../utilities';

import {
	mask
} from 'vue-the-mask';

import CONFIG from "./../../../config.js";

export default {
	name: 'SelectValue',
	directives: {
		mask,
	},
	data() {
		return {
      contract: CONFIG.contract,
			errorMessage: '',
			amount: '',
			other: 0,
			pledges: [
				2000,
				5000,
				11000,
				20000,
				25000,
				32000,
				50000,
				75000,
				106400,
			],
			maxdonation: false,
		};
	},
	computed: {
		candidate() {
			return this.$store.state.candidate;
		},
		formatedOther() {
			return this.other > 0 ? formatBRLDec(this.other) : '';
		}
	},
	mounted() {
		this.getDonationAmount();
	},
	methods: {
		validateForm() {
			const { amount, other, maxdonation } = this;
			const values = amount === 'other' ? { amount, other } : { amount };
			const maxvalue = this.candidate ? this.candidate.max_donation_value : 106400;
			const minvalue = this.candidate ? this.candidate.min_donation_value : 2000;

			if (maxdonation) {
				const validation = validate(values);

				if (amount === 'other' && other < minvalue) {
					this.errorMessage = `O valor mínimo da doação é de R$ ${formatBRL(minvalue)}`;
          this.$refs.otherAmountField.focus();
					return;
				} else if (amount === 'other' && other > maxvalue) {
					this.errorMessage = `O valor máximo da doação é de R$ ${formatBRL(maxvalue)}`;
          this.$refs.otherAmountField.focus();
					return;
				}

				if (validation.valid) {
					this.saveStep(values);
				} else {
					this.errorMessage = 'Todos os campos são obrigatórios';
          this.$refs.errorMessageEl.focus();
				}
			} else {
				this.errorMessage = 'É obrigatório concordar com as condições acima.';
        this.$refs.maxdonation.focus();
			}
		},
		saveStep(values) {
			const data = {
				amount: values.amount !== 'other' ? values.amount : this.cleanOther(values.other),
				step: 'userData',
			};

			this.$store.dispatch('CHANGE_PAYMENT_AMOUNT', data);
		},
		cleanOther(value) {
			return (value + '').replace(/\d{2}$/g, '00');
		},
		checkAmount() {
			if(this.amount !== '') {
				this.validateForm();
			}
		},
getDonationAmount() {
  let amount = getQueryString(window.location.search).valor || '';

  /*
  accepted formats:
  10
  R$20
  R$30,00
  R$ 30,00
  R$    60,00
  R$  60,0
  $10
  $ 10
  20reais
  r$20
  10,00
  50 reais
  500   reais
  500,00 reais
  1000,00   reais
  */

			amount = amount.replace(/(?:^r*\$\s*)|(?:(?:,\d{1,2})*(?:\s*reais)*$)/gi,'');
			amount = parseInt(amount, 10) || 0;

			if(amount) {
				amount *= 100;
				window.location.hash = '#outro-valor';
				this.$refs.maxdonation.focus();

				if(this.$data.pledges.indexOf(amount) === -1) {
					this.$data.amount = 'other';
					return this.$data.other = amount;
				} else {
					return this.$data.amount = amount;
				}
			}
		},
	}
};
</script>



// WEBPACK FOOTER //
// _source/javascript/components/steps/selectValue.vue